

import { Observable } from 'rxjs'; 
import { Parameter } from '../../../../@core/interfaces/common/parameter';

export interface BloodBankParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  }

  export interface BloodBankCollection {
    bloodCollectionId?:any,
      bloodCollectionDate: any,
      bloodCollectionSource: any,
      referenceNo: string,
      donorID: number,
      donorVisitId:number,
      bloodGroupID: number,
      type: string,
      unit: string,
      qty: number,
      expiryEstimateDays:any,
      convertedQty: number,
      expiryDate: any,
      qualityPassFlag: string,
      failReason: string,
      bagBarCode:any,
      bagVolume:any,
      bagType:any,
      componentCombination:any,
      componentName:any,
      componentDate:any,
      noOfComponents:any,
      volume:any,
      componentCode:any,
      componentBagBarCode:any,
      segmentNo:any,
      wholeBlood:any,
      tenantId: any,
      branchId: any,
      createdDate: any,
      createdIP: any,
      createdBy: any,
      updatedDate: any,
      updatedIP: any,
      updatedBy: any,
      blComApprovalby:any,
      blComScreeningDoneby:any,
      blNophysicaldamage:any,
      blLabTestPassed:any,
      blApprovalflag:any,
      blPreparedBy:any,
      blApprovalBy:any,
      bloodCollectionDet:[]
  }

export interface BloodOpeningstock {
  BloodCollectionDate: any,
  BloodCollectionSource: any,
  ReferenceNo: any,
  DonorID: any,
  BloodGroupID: any,
  Type: any,
  Unit: any,
  Qty: any,
  ConvertedQty: any,
  ExpiryEstimateDays: any,
  ExpiryDate: any,
  QualityPassFlag: any,
  FailReason: any,
  TenantId: any,
  BranchId: any,
  CreatedDate: any,
  CreatedIP: any,
  CreatedBy: any,
  UpdatedDate: any,
  UpdatedIP: any,
  UpdatedBy: any
}
 
export abstract class BloodBankModuleData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract getById(url: string,data?: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
